<template>
  <div class="container main-app-container">
    <div class="row m-y-sm">
      <div class="col-md-12">
        <p class="text-lg text-center m-t-0 p-t-0" style="color: black">
          Thank you and we look forward to seeing you.<br />Please can you
          include the names of your family who will be attending and ages of any
          children in the box below.
        </p>
      </div>
    </div>

    <div class="row mb-3 pb-3" v-show="!dataSuccess">
      <div class="col-md-3">&nbsp;</div>
      <div class="col-md-6">
        <b-form-textarea
          class="form-control"
          id="textarea"
          v-model="details"
          placeholder="Names of your family and please let us know the ages of any children attending"
          rows="6"
          max-rows="6"
        ></b-form-textarea>
      </div>
    </div>
    <div class="row m-y-xl pt-3" v-show="!dataSuccess">
      <div class="col-md-3">&nbsp;</div>
      <div class="col-md-6">
        <button
          class="btn btn-primary m-b-xl btn-block text-center"
          @click="saveDetails"
          :disabled="details === ''"
        >
          Send Details
        </button>
      </div>
    </div>

    <div class="row m-y-xl pt-3">
      <div class="col-md-3">&nbsp;</div>
      <div class="col-md-6 align-center">
        <b-alert variant="success" :show="dataSuccess">
          <p style="text-align: center">
            You have successfully sent your details.
          </p></b-alert
        >
      </div>
    </div>
    <div class="row m-y-xl d-flex justify-content-center">
      <div class="col-12">
        <img
          class="img-responsive lazy"
          style="max-width: 600px"
          src="https://webimages.trailfinders.com/image/upload/w_600/v1627485118/gardeninvite/gardenheader.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { saveDetails } from "@/services/api.js";
export default {
  data() {
    return {
      details: "",
      id: "",
      dataSuccess: false,
      dataError: false,
    };
  },
  async mounted() {
    this.id = this.$route.params.id;
  },
  methods: {
    async saveDetails() {
      this.dataSuccess = false;
      this.dataError = false;
      let res = await saveDetails({ id: this.id, details: this.details });
      if (res.status && res.status <= 399) {
        this.dataSuccess = true;
        console.log("done");
      } else {
        this.dataError = true;
        console.log("error");
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/index";
</style>
